import type { FormEvent } from 'react';
import React from 'react';
import { useDispatch } from 'react-redux';

import { track } from 'apis/amethyst';
import { evLaunchCalendarSubscriptionClick, LAUNCH_CALENDAR_FLOW_TYPE } from 'events/launchCalendar';
import { LAUNCH_CALENDAR_NOTIFICATION_SUBSCRIBED_COPY } from 'constants/launchCalendar';
import { INTERNET_EMAIL } from 'common/regex';
import MelodyModal from 'components/common/MelodyModal';
import { subscribeToUpcomingStylesNotification } from 'actions/launchCalendar';
import type { AppDispatch } from 'entrypoints/bootstrapOnClient';

import css from 'styles/components/launchcalendar/launchCalendarNotifyMeModal.scss';

interface LaunchCalendarNotifyMeProps {
  heading: string;
  styleId: number;
  contentLabel: string;
  isOpen: boolean;
  isItemSetupCompleted: boolean;
  setLCNotifyMeModalOpen: (isOpen: boolean) => void;
}

export const LaunchCalendarNotifyMeModal = ({
  heading,
  styleId,
  contentLabel,
  isOpen,
  setLCNotifyMeModalOpen,
  isItemSetupCompleted
}: LaunchCalendarNotifyMeProps) => {
  const dispatch: AppDispatch = useDispatch();
  const [isSubscribedForNotification, setIsSubscribedForNotification] = React.useState(false);

  const submitSubscriptionForUpcomingStyle = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const {
      currentTarget: { emailAddress }
    } = e;
    dispatch(subscribeToUpcomingStylesNotification(emailAddress.value, styleId));
    setIsSubscribedForNotification(true);
    track(() => [
      evLaunchCalendarSubscriptionClick,
      {
        flowType: LAUNCH_CALENDAR_FLOW_TYPE.NotifyMeModal,
        isItemSetupCompleted,
        styleId
      }
    ]);
  };

  const buildNotifyMeSection = () => {
    const regex = INTERNET_EMAIL.toString().slice(2, -2);

    if (isSubscribedForNotification) {
      return <div className={css.notificationSubscribed}>{LAUNCH_CALENDAR_NOTIFICATION_SUBSCRIBED_COPY}</div>;
    }

    return (
      <div>
        <form method="post" onSubmit={submitSubscriptionForUpcomingStyle}>
          <div className={css.styleNotifyContainer}>
            <header>Enter your email below and we’ll let you know when this product becomes available!</header>
            <fieldset className={css.fieldSet}>
              <label className={css.fieldSet__label} htmlFor="productNotifyEmailAddress">
                Email
              </label>
              <input
                type="email"
                id="upcomingStyleNotifyEmailAddress"
                className={css.emailAddress}
                name="emailAddress"
                pattern={regex}
                required
                aria-describedby="errorMsg"
              />
            </fieldset>
          </div>
          <div className={css.actionBar}>
            <button type="submit" className={css.sendButton}>
              Continue
            </button>
          </div>
        </form>
      </div>
    );
  };

  return (
    <MelodyModal
      buttonTestId="close"
      className={isSubscribedForNotification ? css.modal_success : css.modal}
      heading={heading}
      headingClassName={css.headingContainer}
      contentLabel={contentLabel}
      headingTestId="launchCalendarNotifyMeModalHeader"
      isOpen={isOpen}
      onRequestClose={() => setLCNotifyMeModalOpen(false)}
    >
      {buildNotifyMeSection()}
    </MelodyModal>
  );
};

export default LaunchCalendarNotifyMeModal;
